import { z } from 'zod';

import { FYI_MAX_FILE_BYTES } from './constant';

const entityWithName = z.object({ id: z.string(), name: z.string() });

export const FyiItemFormSchema = z
  .object({
    title: z.string(),
    description: z.string(),
    recipients: z.array(entityWithName),
    fabricator: entityWithName.nullable().optional(),
    attachments: z
      .array(z.object({ id: z.string(), size: z.number().optional() }))
      .optional(),
  })
  .superRefine((data, ctx) => {
    if (!data.title?.trim()) {
      ctx.addIssue({
        path: ['title'],
        message: 'This field is required',
        code: 'custom',
      });
    }

    if (!data.description?.trim()) {
      ctx.addIssue({
        path: ['description'],
        message: 'This field is required',
        code: 'custom',
      });
    }

    if (!data.recipients?.length) {
      ctx.addIssue({
        path: ['recipients'],
        message: 'Select at least one recipient',
        code: 'custom',
      });
    }

    if ((data.attachments ?? []).some((a) => (a.size ?? 0) > FYI_MAX_FILE_BYTES)) {
      ctx.addIssue({
        path: ['attachments'],
        message: 'Files must be 30 MB or smaller',
        code: 'custom',
      });
    }
  });

export type FyiItemFormValues = z.infer<typeof FyiItemFormSchema>;
